import shop from "../api/shop";
import {
  CUSTOMERS_STORE,
  CUSTOMER_ACTION_BAR,
  CUSTOMER_ACTION_TYPE,
  FILTER_CUSTOMERS,
  SET_SELECTED_USER,
  CART_STORE,
  CART_AVAILABLE_TO_IMPORT,
  CLEAR_CUSOMER_DATA,
  LOADING_CART,
  LOADING_CUSTOMER,
  RESET_STATE,
  SET_CART_NOTE,
  DISABLE_OPENED_ORDER,
  CUSTOMER_CART_LOADING,
  CUSTOMER_CART_STORE,
  CUSTOMER_CART_CLEAR,
  GET_TOP_SELLING_COMMON,
  GET_TOP_SELLING_USER
} from "./actionTypes";
import { customerState } from "./stateModel";

const clearCustomerCartUnsafe = () => ({
  type: CUSTOMER_CART_CLEAR
});

export const clearCustomerCart = () => dispatch => {
  dispatch(clearCustomerCartUnsafe());
};

const loadingCustomerCartUnsafe = state => ({
  type: CUSTOMER_CART_LOADING,
  state
});

export const loadingCustomerCart = state => dispatch => {
  dispatch(loadingCustomerCartUnsafe(state));
};

const storeCustomerCartUnsafe = cart => ({
  type: CUSTOMER_CART_STORE,
  cart
});

export const storeCustomerCartToPreview = cartItems => dispatch => {
  dispatch(storeCustomerCartUnsafe(cartItems));
};

const storeCustomersUnsafe = customers => ({
  type: CUSTOMERS_STORE,
  customers
});

export const storeCustomers = customers => dispatch => {
  dispatch(storeCustomersUnsafe(customers));
};

const setOpenedActionsUnsafe = id => ({
  type: CUSTOMER_ACTION_BAR,
  id
});

export const setOpenedActions = id => (dispatch, getState) => {
  const currentId = getState().customer.actionBarActive;
  dispatch(setOpenedActionsUnsafe(id !== currentId ? id : null));
};
// Action BAR fncs
const customerActionUnsafe = value => ({
  type: CUSTOMER_ACTION_TYPE,
  value
});

const setActiveUserUnsafe = customer => ({
  type: SET_SELECTED_USER,
  customer
});

export const storeCustomerCart = cart => ({
  type: CART_STORE,
  cart
});
const setAvailableCart = state => ({
  type: CART_AVAILABLE_TO_IMPORT,
  state
});

const sortCartItemsBySKU = cartItems =>
  cartItems.sort((a, b) =>
    a.code
      .toString()
      .toLowerCase()
      .localeCompare(b.code.toString().toLowerCase())
  );

export const customerAction = value => (dispatch, getState) => {
  dispatch(setNoteUnsafe(null));
  dispatch(customerActionUnsafe(value));
  const { list } = getState().customer;
  const customer = list.filter(
    customer => customer.personal.id === getState().customer.actionBarActive
  );
  dispatch(setActiveUserUnsafe(customer[0]));
  dispatch(setOpenedActionsUnsafe(null));
  // load customer cart
  shop.hasCustomerCartItems(customer[0].personal.id, cartFromApi => {
    cartFromApi.then(cartItems => {
      dispatch(setAvailableCart(cartItems > 0));
    });
  });
  dispatch(loadingCartItems(true));
  shop.getCartItems(customer[0].personal.id, value, cartFromApi => {
    cartFromApi.then(cartItems => {
      dispatch(storeCustomerCart(sortCartItemsBySKU(cartItems)));
      dispatch(loadingCartItems(false));
    });
  });
  shop.getCartNote(customer[0].personal.id, value, cartNoteFromApi => {
    cartNoteFromApi.then(cartNote => {
      dispatch(setNoteUnsafe(cartNote[0]));
    });
  });
};

const setNoteUnsafe = note => ({
  type: SET_CART_NOTE,
  note
});

export const customerActionType = value => (dispatch, getState) => {
  dispatch(setNoteUnsafe(null));
  dispatch(customerActionUnsafe(value));
  const customer = getState().common.user;
  // load customer cart
  shop.hasCustomerCartItems(customer.personal.id, cartFromApi => {
    cartFromApi.then(cartItems => {
      dispatch(setAvailableCart(cartItems > 0));
    });
  });
  dispatch(loadingCartItems(true));
  shop.getCartItems(customer.personal.id, value, cartFromApi => {
    cartFromApi.then(cartItems => {
      dispatch(storeCustomerCart(sortCartItemsBySKU(cartItems)));
      dispatch(loadingCartItems(false));
    });
  });

  shop.getCartNote(customer.personal.id, value, cartNoteFromApi => {
    cartNoteFromApi.then(cartNote => {
      dispatch(setNoteUnsafe(cartNote[0]));
    });
  });
};

export const loadingCartItems = status => ({
  type: LOADING_CART,
  status
});

export const clearCustomerData = () => ({
  type: CLEAR_CUSOMER_DATA
});

export const loadingCustomers = status => ({
  type: LOADING_CUSTOMER,
  status
});

// FILTER FNCS

const changeFilterUnsafe = (term, col) => ({
  type: FILTER_CUSTOMERS,
  term,
  col
});

export const changeCustomersList = (term, type) => dispatch => {
  dispatch(changeFilterUnsafe(term, type));
};

const getCommonTopSellingProductsUnsafe = (list) => ({
  type: GET_TOP_SELLING_COMMON,
  list
});

const getUserTopSellingProductsUnsafe = (list) => ({
  type: GET_TOP_SELLING_USER,
  list
});

export const getTopSellingProducts = (list, type) => (dispatch, getState) => {
  if (type === 'user') {
    dispatch(getUserTopSellingProductsUnsafe(list));
  } else {
    dispatch(getCommonTopSellingProductsUnsafe(list));

  }
};

const loadingUnsafe = status => console.log(status);

export const sortProductsList = (sortBy, sortOrder) => (dispatch, getState) => {
  dispatch(loadingUnsafe(!getState().common.loading));
  shop.getSortedProducts(
    sortBy,
    sortOrder,
    getState().product.list,
    sortedProducts => {
      dispatch(loadingUnsafe(!getState().common.loading));
    }
  );
};

export const getOpenedActionBarId = state => state || null;
export const getCustomers = state => state || [];
export const getCustomerAction = state => state || null;

// ------------------------------------
// Reducer
// ------------------------------------

const filterCustomers = (state, { col, term }) => {
  const { list } = state;
  const searchingTerm = term.toString().toLowerCase();
  const searchList = list.filter(customer => {
    switch (col) {
      case "name":
        return (
          customer.company.company &&
          customer.company.company
            .toString()
            .toLowerCase()
            .includes(searchingTerm)
        );
      case "location":
        return (
          customer.company.street
            .toString()
            .toLowerCase()
            .includes(searchingTerm) ||
          customer.company.city
            .toString()
            .toLowerCase()
            .includes(searchingTerm) ||
          customer.company.zip
            .toString()
            .toLowerCase()
            .includes(searchingTerm) ||
          customer.shippingAddress.street
            .toString()
            .toLowerCase()
            .includes(searchingTerm) ||
          customer.shippingAddress.city
            .toString()
            .toLowerCase()
            .includes(searchingTerm) ||
          customer.shippingAddress.zip
            .toString()
            .toLowerCase()
            .includes(searchingTerm)
        );
      default:
        return (
          customer.personal.code &&
          customer.personal.code
            .toString()
            .toLowerCase()
            .includes(searchingTerm)
        );
    }
  });
  return {
    ...state,
    filter: { ...state.filter, [col]: term },
    searchList: searchList
  };
};

export default function customerReducer(state = customerState, action) {
  switch (action.type) {
    case CUSTOMERS_STORE:
      let customerShortList = [];
      action.customers &&
        action.customers.length > 0 &&
        action.customers.map(c => {
          customerShortList[c.personal.id] = c.personal.code;
        });
      return {
        ...state,
        list: action.customers,
        searchList: action.customers,
        shortList: customerShortList
      };

    case CUSTOMER_ACTION_BAR:
      return {
        ...state,
        actionBarActive: action.id
      };

    case CUSTOMER_ACTION_TYPE:
      return {
        ...state,
        actionOnCustomer: action.value
      };

    case FILTER_CUSTOMERS:
      return filterCustomers(state, action);

    case CLEAR_CUSOMER_DATA:
      return { ...customerState, list: state.list };
    case LOADING_CUSTOMER:
      return { ...state, loading: action.status };
    case RESET_STATE:
      return customerState;
    case DISABLE_OPENED_ORDER:
      const currentUserId = action.customerId;
      const customers = state.list.map(c => {
        if (c.personal.id === currentUserId) {
          const oo = Object.assign({}, c.orderType);
          Object.keys(oo).map(key => {
            oo[key] = oo[key] === "oz" ? null : oo[key];
          });
          c.orderType = oo;
        }
        return c;
      });
      return {
        ...state,
        list: customers
      };
    // return state;
    case CUSTOMER_CART_LOADING:
      return { ...state, loadingCart: action.state };
    case CUSTOMER_CART_STORE:
      return { ...state, ...action };
    case CUSTOMER_CART_CLEAR:
      return { ...state, cart: [] };
    case GET_TOP_SELLING_COMMON:
      return {
        ...state,
        topSellingProducts: {
          ...state.topSellingProducts,
          common: action.list
        }
      };
    case GET_TOP_SELLING_USER:
      return {
        ...state,
        topSellingProducts: {
          ...state.topSellingProducts,
          user: action.list
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/customer.js